// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + ({"8":"home-view","247":"category-view","348":"footer","500":"product-view","882":"toolbar"}[chunkId] || chunkId) + "." + {"8":"f8e3acf6","217":"79513e0c","247":"971b39b1","348":"0f1c54f8","500":"f0417e39","882":"364911d2"}[chunkId] + ".css";
};